import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitonashikcab() {



  const cardData = {
    keyword: " Mumbai to Nashik Cab ",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Nashik cab service, providing safe, comfortable, and affordable intercity travel for families, pilgrims, business travelers, and tourists. The distance between Mumbai and Nashik is approximately 165–180 km, and the journey takes around 3.5–4.5 hours via NH160 and Mumbai–Nashik Highway. Our professional drivers ensure a smooth and stress-free ride with timely pickup, highway expertise, and well-maintained vehicles. We offer flexible booking options including one-way cabs, round trips, and customized tour packages. Our fleet includes hatchbacks, sedans, SUVs, Innova, Ertiga, Kia Carens, Innova Crysta, and Tempo Travellers suitable for all group sizes. With 24/7 availability, transparent pricing, and easy booking, Royal Route Cab is a trusted choice for Mumbai to Nashik cab service.",

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga",
    "description": "Trimbakeshwar Jyotirlinga is one of the most sacred Shiva temples located near Nashik and is part of the twelve Jyotirlingas in India. The temple is situated at the origin of the holy Godavari River and is surrounded by the Brahmagiri hills. Devotees visit here for spiritual blessings and important rituals like Kaal Sarp Dosh and Narayan Nagbali puja. The divine atmosphere and religious significance make it a must-visit destination for pilgrims traveling from Mumbai."
  },
  {
    "title": "Sula Vineyards",
    "description": "Sula Vineyards is one of India’s most famous wine estates, located in Nashik. It offers wine tasting tours, vineyard walks, and scenic views of lush grape plantations. Tourists from Mumbai often visit this destination for weekend getaways, enjoying fine dining, sunset views, and premium wine experiences. It is a popular leisure stop for couples and groups."
  },
  {
    "title": "Panchavati",
    "description": "Panchavati is a highly religious area in Nashik associated with Lord Ram’s exile period. It features several temples such as Kalaram Temple and Sita Gufa. The area is deeply connected with Hindu mythology and attracts thousands of devotees every year. The peaceful surroundings and riverbanks make it a spiritually enriching stop."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "Saptashrungi Devi Temple is located on a hill near Nashik and is one of the Shakti Peethas. Devotees climb steps or use ropeways to reach the temple. It is believed that the goddess fulfills wishes of her devotees. The scenic hilltop location offers panoramic views and a strong spiritual experience."
  },
  {
    "title": "Anjaneri Hills",
    "description": "Anjaneri Hills is believed to be the birthplace of Lord Hanuman and is a popular trekking destination near Nashik. It offers beautiful landscapes, waterfalls during monsoon, and a peaceful environment for nature lovers and pilgrims alike. It is ideal for short adventure trips from Mumbai."
  },
  {
    "title": "Nashik Wine Tourism Route",
    "description": "Nashik is known as the Wine Capital of India, with multiple vineyards like Sula, York, and Grover Zampa. Visitors enjoy guided tours, wine tasting sessions, and scenic vineyard views. It is a popular attraction for weekend travelers from Mumbai looking for relaxation and leisure experiences."
  },
  {
    "title": "Pandavleni Caves",
    "description": "Pandavleni Caves are ancient rock-cut caves dating back over 2,000 years, located on a hill near Nashik. These caves reflect Buddhist architecture and offer a great trekking experience along with historical significance. The top viewpoint provides a panoramic view of Nashik city."
  },
  {
    "title": "Godavari River Ghats",
    "description": "The Godavari River Ghats in Nashik are sacred bathing and ritual sites where pilgrims perform religious ceremonies. The ghats are especially crowded during festivals like Kumbh Mela. The peaceful riverside atmosphere makes it a significant spiritual and cultural destination."
  },
  {
    "title": "Mumbai–Nashik Highway Journey",
    "description": "The Mumbai–Nashik Highway (NH160) is a well-developed route offering smooth driving conditions, scenic landscapes, and multiple rest stops. It makes intercity travel comfortable and efficient, especially for families and groups traveling by cab. The journey is safe and enjoyable with professional drivers."
  },
  {
    "title": "One-Way & Round Trip Options",
    "description": "Mumbai to Nashik cab service offers both one-way and round trip options depending on travel needs. One-way is ideal for drop-only travel, while round trip is suitable for same-day return or multi-day trips. This flexibility helps passengers plan their journey conveniently and cost-effectively."
  }
],






services: [
  {
    name: "Nashik to Mumbai Cab",
    description: "Nashik to Mumbai cab service offers comfortable and reliable intercity travel for business trips, airport transfers, and family journeys. The route ensures smooth highway connectivity with experienced drivers. Clean vehicles enhance comfort. It guarantees a safe and hassle-free ride."
  },
  {
    name: "Mumbai to Nashik Cabs",
    description: "Mumbai to Nashik cabs provide convenient travel options for individuals and groups. Ideal for short trips, corporate travel, and weekend getaways. Comfortable vehicles ensure a smooth journey. It guarantees reliable transportation."
  },
  {
    name: "Mumbai to Nashik Taxi",
    description: "Mumbai to Nashik taxi offers private and flexible travel with door-to-door pickup. Suitable for families, tourists, and business travelers. Professional drivers ensure safety. It guarantees a comfortable ride."
  },
  {
    name: "Mumbai to Nashik Taxi Service",
    description: "Mumbai to Nashik taxi service ensures dependable transportation with trained drivers and well-maintained vehicles. Ideal for intercity travel. Flexible booking options enhance convenience. It guarantees a smooth journey."
  },
  {
    name: "Mumbai Airport to Nashik Cab",
    description: "Mumbai airport to Nashik cab provides direct transfers from airport terminals to Nashik city. Ideal for travelers arriving by flight. Professional drivers ensure timely pickup. It guarantees a stress-free journey."
  },
  {
    name: "Nashik to Mumbai Airport Cab",
    description: "Nashik to Mumbai airport cab ensures timely transportation for catching flights. Ideal for early morning or late-night travel. Comfortable vehicles enhance convenience. It guarantees punctual service."
  },
  {
    name: "Nashik to Mumbai Taxi Service",
    description: "Nashik to Mumbai taxi service offers reliable long-distance travel for business and leisure purposes. Professional drivers ensure safe driving. Clean vehicles enhance comfort. It guarantees a pleasant journey."
  },
  {
    name: "Nashik to Mumbai Taxi",
    description: "Nashik to Mumbai taxi provides efficient and comfortable travel for individuals and groups. This service includes flexible pickup options and smooth highway travel. It guarantees reliability."
  },
  {
    name: "Mumbai Nashik Taxi",
    description: "Mumbai Nashik taxi offers easy and convenient booking for intercity travel. Ideal for one-way and round trips. Comfortable vehicles ensure a pleasant journey. It guarantees smooth travel."
  },
  {
    name: "Mumbai Airport to Nashik Taxi",
    description: "Mumbai airport to Nashik taxi offers direct and convenient travel for airport passengers. Door-to-door service ensures comfort. Professional drivers enhance safety. It guarantees a hassle-free ride."
  },
  {
    name: "Mumbai to Nashik Taxi Price",
    description: "Mumbai to Nashik taxi price depends on vehicle type and trip duration. Transparent pricing ensures no hidden charges. Customers can choose budget or premium options. It helps in easy planning."
  },
  {
    name: "Nashik Mumbai Taxi",
    description: "Nashik Mumbai taxi provides dependable travel solutions for daily and occasional trips. Suitable for both personal and business travel. It guarantees a comfortable and reliable experience."
  },
  {
    name: "Nasik to Mumbai Cab",
    description: "Nasik to Mumbai cab offers affordable and convenient travel for long-distance journeys. Ideal for families and corporate travelers. Professional drivers ensure smooth rides. It guarantees a safe journey."
  },
  {
    name: "Mumbai to Nashik Cab Service",
    description: "Mumbai to Nashik cab service provides reliable and flexible travel options for intercity journeys. Clean vehicles and experienced drivers ensure comfort. It guarantees a smooth and safe experience."
  },
  {
    name: "Nashik to Mumbai Cab Service",
    description: "Nashik to Mumbai cab service ensures dependable transportation with well-maintained vehicles and trained drivers. Ideal for business and family travel. It guarantees a comfortable journey."
  },
  {
    name: "Mumbai to Nashik Cab Fare",
    description: "Mumbai to Nashik cab fare is transparent and based on vehicle type and travel plan. Customers receive clear pricing before booking. It helps in planning travel expenses effectively."
  },
  {
    name: "Mumbai Airport to Nashik Taxi Fare",
    description: "Mumbai airport to Nashik taxi fare offers clear and competitive pricing based on distance and vehicle type. No hidden charges ensure trust. It helps customers plan their travel budget."
  },
  {
    name: "Nashik to Mumbai Airport Cab Service",
    description: "Nashik to Mumbai airport cab service provides reliable transportation for airport transfers. Professional drivers ensure timely arrival. Comfortable vehicles enhance travel experience. It guarantees a stress-free journey."
  },
  {
    name: "Nashik to Mumbai Cab Price",
    description: "Nashik to Mumbai cab price varies depending on vehicle selection and trip duration. Budget and premium options are available. Transparent pricing ensures convenience. It helps in easy planning."
  }
],

tableData: [
  ["Nashik to Mumbai Cab", "Mumbai to Nashik Cabs"],
  ["Mumbai to Nashik Taxi", "Mumbai to Nashik Taxi Service"],
  ["Mumbai Airport to Nashik Cab", "Nashik to Mumbai Airport Cab"],
  ["Nashik to Mumbai Taxi Service", "Nashik to Mumbai Taxi"],
  ["Mumbai Nashik Taxi", "Mumbai Airport to Nashik Taxi"],
  ["Mumbai to Nashik Taxi Price", "Nashik Mumbai Taxi"],
  ["Nasik to Mumbai Cab", "Mumbai to Nashik Cab Service"],
  ["Nashik to Mumbai Cab Service", "Mumbai to Nashik Cab Fare"],
  ["Mumbai Airport to Nashik Taxi Fare", "Nashik to Mumbai Airport Cab Service"],
  ["Nashik to Mumbai Cab Price", ""]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Nashik Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Nashik cab service, ideal for family trips, business travel, and religious visits."
  },
  {
    WhyChooseheading: "Affordable Taxi Fare Options",
    WhyChoosedescription: "Cab fare starts from approximately ₹2200 to ₹3500 for sedan and varies based on vehicle type and travel date."
  },
  {
    WhyChooseheading: "Experienced Highway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in Mumbai–Nashik highway routes, ensuring safe driving and timely arrival."
  },
  {
    WhyChooseheading: "Perfect for Religious & Wine Tours",
    WhyChoosedescription: "Nashik is famous for Trimbakeshwar Jyotirlinga and vineyards, making it ideal for both spiritual and leisure trips."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return trips to Nashik."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for group travel."
  },
  {
    WhyChooseheading: "Trusted Intercity Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Nashik cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Nashik cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Nashik for one-way and round trips." },
  { question: "What is the distance between Mumbai and Nashik?", answer: "The distance is approximately 165 to 180 km by road." },
  { question: "How much time does it take to reach Nashik?", answer: "It takes around 3.5 to 4.5 hours depending on traffic and route." },
  { question: "What is the taxi fare for this route?", answer: "Taxi fare starts from ₹2200–₹3500 for sedan and increases based on vehicle type." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is same-day return available?", answer: "Yes, same-day return packages are available." },
  { question: "Do you provide pickup from all areas in Mumbai?", answer: "Yes, we provide pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for weekends and peak travel times." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Deshmukh",
    feedback: "The Mumbai to Nashik journey with Royal Route Cabs was very smooth and comfortable. The driver was punctual and ensured a safe highway travel experience.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Patil",
    feedback: "Great experience traveling from Mumbai to Nashik. The cab was clean, the ride was comfortable, and the service felt reliable throughout the journey.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Nashik Cab Service",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-nashik-cab.jpg", // replace if needed
  "description": "Book Mumbai to Nashik cab service with Royal Route Cabs for safe, comfortable, and affordable intercity travel. Available for one-way and round-trip taxi service, airport transfers, and outstation journeys with sedan, SUV, Innova, and chauffeur-driven options.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3600",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199", // indicative one-way fare (adjust as needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-nashik-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Nashik Cab Service | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Nashik cab service with Royal Route Cabs. Affordable and reliable taxi for one-way, round-trip, and airport transfers with sedan, SUV, Innova options."
  />

  <meta
    name="keywords"
    content="mumbai to nashik cabs, mumbai to nashik taxi, mumbai to nashik taxi service, mumbai airport to nashik cab, nashik to mumbai airport cab, nashik to mumbai taxi service, nashik to mumbai taxi, mumbai nashik taxi, mumbai airport to nashik taxi, mumbai to nashik taxi price"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitonashikcab;